import { EmptyState } from '@/components/feedback/EmptyState'
import { usePageMeta } from '@/app/router/routeMeta'
import { useTermLabel } from '@/hooks/useTerm'

/**
 * Stands in for a destination the navigation already offers but that has not
 * been built yet. It names the page it will become, so the shell can be used
 * and reviewed before the pages behind it exist.
 */
export function ComingSoonPage() {
  const meta = usePageMeta()
  const termLabel = useTermLabel()

  return (
    <EmptyState
      title={`${meta ? termLabel(meta.title) : 'Diese Seite'} entsteht gerade`}
      description="Der Bereich ist in Arbeit. Die Navigation und der Arbeitsbereich funktionieren bereits."
    />
  )
}
